<template>
  <div
    id="app"
    :class="{
      [$style.appComp]: true,
      [$style.appCompNewDesign]: isNewDesign,
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone,
      [$style.big]: el.is.big
    }"
  >
    <div
      :class="{
        [$style.container]: true,
        [$style.containerNewDesign]: isNewDesign,
        [$style.animation]: animationTrigger
      }"
    >
      <!-- EXTERNAL SLOT FOR OPTIONAL FIRST SLIDE -->
      <slot v-if="hasExternalSlide"></slot>

      <template v-if="!hasExternalSlide">
        <!-- PROGRESS BAR -->
        <ProgressBar v-if="isNotSlide_0" />

        <!-- SLIDE -->
        <SlideWrapper @selected="onSelected" />

        <!-- BUTTONS -->
        <div
          :class="{
            [$style.buttons]: true
          }"
        >
          <div
            :class="$style.icons"
            v-if="isContactFormSlide && !el.is.phone && !el.is.port"
          >
            <div :class="[$style.iconDiv, $style.iconSmall]">
              <img
                :class="$style.img"
                src="@/assets/images/icon-ssl.svg"
                alt="ssl icon"
              />
            </div>
            <div :class="[$style.iconDiv, $style.iconSmall]">
              <img
                :class="$style.img"
                src="@/assets/images/icon-serverstandort.svg"
                alt="serverstandort icon"
              />
            </div>
            <div :class="[$style.iconDiv, $style.iconBig]">
              <img
                :class="$style.img"
                src="@/assets/images/icon-dsgvo.svg"
                alt="dsgvo icon"
              />
            </div>
          </div>
          <div :class="$style.backNext">
            <!-- BACK BUTTON -->
            <BaseButtonBack @back="onBack" :class="$style.back" />
            <span
              :class="$style.overviewSign"
              v-if="isOverviewSlide && !el.is.phone"
            >
              <span :class="$style.imgBox"
                ><img
                  src="./assets/images/icon-calculation-check.svg"
                  alt="checked icon"
              /></span>
              <span :class="$style.overviewText"
                >Datenschutzkonforme Übertragung</span
              >
            </span>
            <!-- NEXT BUTTON -->
            <BaseButtonNext
              ref="nextBtn"
              @next="onNext"
              @checkProps="propHandler"
              :class="$style.next"
            />
          </div>
        </div>
        <!-- ICON FOR OVERVIEW SLIDE -->
        <span
          :class="$style.overviewSign"
          v-if="isOverviewSlide && el.is.phone"
        >
          <span :class="$style.imgBox"
            ><img
              src="./assets/images/icon-calculation-check.svg"
              alt="checked icon"
          /></span>
          <span :class="$style.overviewText"
            >Datenschutzkonforme Übertragung</span
          >
        </span>
        <!-- ITEMS FOR CONTACT FORM -->
        <div :class="$style.listItems">
          <div v-if="isContactFormSlide" :class="$style.listItem">
            <span :class="$style.imgBox"
              ><img :src="getCheckedIcon" alt="checked icon"/></span
            ><span :class="$style.text">Kostenlos</span>
          </div>
          <div v-if="isContactFormSlide" :class="$style.listItem">
            <span :class="$style.imgBox"
              ><img :src="getCheckedIcon" alt="checked icon"/></span
            ><span :class="$style.text"
              >SSL verschlüsselte Datenübertragung</span
            >
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { scroller } from 'vue-scrollto/src/scrollTo'
import { ResponsiveMixin } from 'vue-responsive-components'
import SlideWrapper from '@/components/SlideWrapper.vue'
import ProgressBar from '@/components/ProgressBar.vue'
import BaseButtonBack from '@/components/ui/BaseButtonBack.vue'
import BaseButtonNext from '@/components/ui/BaseButtonNext.vue'
import { data_hausanker } from '@/config/data_hausanker.js'

import store from '@/store'

export default {
  name: 'App',
  props: [
    // design
    'design',

    // first slide
    'choice',
    'first_slide',
    'calculator_variant',

    // hidden inputs
    'form_oid',
    'form_returl',
    'form_leadorigin',
    'form_website'
    // ,
    // 'form_msclkid',
    // 'form_fbclip',
    // 'form_utm',
    // 'form_faorderid',
    // 'form_gclid'
  ],
  data() {
    return {
      animationTrigger: false,
      timeout: null,
      externalSlideTimeout: null
      // localStorageTimeout: null
    }
  },
  components: {
    ProgressBar,
    SlideWrapper,
    BaseButtonBack,
    BaseButtonNext
  },
  mixins: [ResponsiveMixin],
  breakpoints: {
    land: el => el.width <= 1199,
    port: el => el.width <= 991,
    phone: el => el.width <= 768,
    small: el => el.width <= 374,
    big: el => el.width > 1800
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    // note: new design
    getCheckedIcon() {
      if (this.isNewDesign) {
        return require('./assets/images/checked_new.svg')
      } else {
        return require('./assets/images/checked-1.svg')
      }
    },
    // ENUMS
    slideNames() {
      return store.state.slideNames
    },
    propertyTypes() {
      return store.state.propertyTypes
    },
    formNames() {
      return store.state.formNames
    },
    hasExternalSlide() {
      return this.first_slide === 'yes' && !this.propertyType
    },
    isContactFormSlide() {
      return this.slide.slideName === this.slideNames.SLIDE_21
    },
    isOverviewSlide() {
      return this.slide.slideName === this.slideNames.SLIDE_20
    },
    isNotSlide_0() {
      return this.slide.slideName !== this.slideNames.SLIDE_0
    },
    currentSlide() {
      return store.state.currentSlide
    },
    propertyType() {
      return store.state.propertyType
    },
    slides() {
      return store.state.slides
    },
    slide() {
      return store.getters['slide']
    }
  },
  methods: {
    // scroll to next
    onSelected() {
      if (this.slide.scrollToNext && (this.el.is.phone || this.el.is.small)) {
        const scroll = scroller()
        const nextBtnEl = this.$refs.nextBtn.$el
        scroll(nextBtnEl, { duration: 1000, offset: -300 })
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    propHandler() {
      // edit hidden inputs
      for (const key in this.$props) {
        if (key.startsWith('form_') && this.$props[key]) {
          store.dispatch('editHiddenInputs', {
            propName: key,
            value: this.$props[key]
          })
        }
      }
    },
    onNext() {
      if (this.currentSlide < this.slides.length - 1) {
        // edit current slide
        store.dispatch('editCurrentSlide', this.currentSlide + 1)

        if (this.currentSlide === this.slides.length - 1) {
          // emit after lead finished
          this.$emit('afterleadfinished', {
            slideName:
              this.slides[this.currentSlide].slideName +
              '-' +
              this.propertyType,
            tagVariant: store.getters.getTagVariant
          })
        }
        if (
          store.getters['slide'].slideName !==
            store.state.slideNames.SLIDE_22 &&
          !store.getters['sendData']
        ) {
          store.dispatch('setLS')
        } else {
          store.dispatch('clearLS')
        }
      }
      this.scrollToTop()
    },
    onBack() {
      // back: if has external slide than just remove propety type to go back on external
      if (this.currentSlide === 1 && this.first_slide === 'yes') {
        return store.dispatch('editPropertyType', '')
      }
      if (this.currentSlide > 0) {
        // edit current slide
        store.dispatch('editCurrentSlide', this.currentSlide - 1)
        store.dispatch('setLS')
      }
      this.scrollToTop()
    }
  },
  created() {
    // note: add values from calculator reduced
    const immobilienwert = localStorage.getItem('immobilienwert')
    const wunschbetrag = localStorage.getItem('wunschbetrag')

    if (immobilienwert && wunschbetrag) {
      store.dispatch('setCalculatorReducedData', {
        immobilienwert: Number(immobilienwert),
        wunschbetrag: Number(wunschbetrag)
      })
    }
    if (this.$props.design) {
      store.dispatch('setDesign', this.$props.design)
      store.dispatch('setSalesforceDesign', this.$props.design)
      store.dispatch('setHausankerData', data_hausanker)
    }
    // for checkout event on hausanker for external slide
    if (this.hasExternalSlide && this.isNewDesign && !this.isNotSlide_0) {
      this.externalSlideTimeout = setTimeout(() => {
        this.$emit('afterslideenter', {
          slideName: 'slide-00',
          slideNumber: '1',
          tagVariant: ''
        })
      }, 1000)
    }

    store.dispatch('connectLS')
    this.localStorageTimeout = setTimeout(() => {
      store.dispatch('clearLS')
    }, 600000)

    // set variant of calculator
    if (
      this.$props.calculator_variant === '1' ||
      !this.$props.calculator_variant
    ) {
      store.dispatch('setVariant', 1)
    } else if (this.$props.calculator_variant === '2') {
      store.dispatch('setVariant', 2)
    }

    // edit hidden inputs
    for (const key in this.$props) {
      if (key.startsWith('form_') && this.$props[key]) {
        store.dispatch('editHiddenInputs', {
          propName: key,
          value: this.$props[key]
        })
      }
    }
    // animation
    this.timeout = setTimeout(() => {
      this.animationTrigger = true
    }, 300)
    store.dispatch('setEl', this.el)

    // custom attributes for choosing property
    if (
      this.choice === this.propertyTypes.HOUSE ||
      this.choice === this.propertyTypes.APARTMENT
    ) {
      store.dispatch('saveData', {
        value: this.choice,
        slideName: this.slideNames.SLIDE_0,
        formName: this.formNames.FORM_0_1
      })
      store.dispatch('editSlidesByPropertyType', this.choice)
    }

    // custom url params for choosing propery
    const urlParams = new URLSearchParams(window.location.search)
    const paramChoice = urlParams.get('choice')

    if (
      paramChoice &&
      (paramChoice === this.propertyTypes.HOUSE ||
        paramChoice === this.propertyTypes.APARTMENT)
    ) {
      store.dispatch('saveData', {
        value: paramChoice,
        slideName: this.slideNames.SLIDE_0,
        formName: this.formNames.FORM_0_1
      })
      store.dispatch('editSlidesByPropertyType', paramChoice)
    }
  },
  watch: {
    choice() {
      // custom attributes for choosing propery
      if (
        this.choice === this.propertyTypes.HOUSE ||
        this.choice === this.propertyTypes.APARTMENT
      ) {
        store.dispatch('saveData', {
          value: this.choice,
          slideName: this.slideNames.SLIDE_0,
          formName: this.formNames.FORM_0_1
        })
        store.dispatch('editSlidesByPropertyType', this.choice)
      }
    },
    currentSlide(newVal, oldVal) {
      this.animationTrigger = false

      // emit before slide left
      let addition =
        this.slides[oldVal].slideName === this.slideNames.SLIDE_0
          ? ''
          : '-' + this.propertyType
      this.$emit('beforeslideleft', {
        slideName: this.slides[oldVal].slideName + addition
      })

      this.timeout = setTimeout(() => {
        this.animationTrigger = true
        // emit after slide enter
        addition =
          this.slides[newVal].slideName === this.slideNames.SLIDE_0
            ? ''
            : '-' + this.propertyType

        this.$emit('afterslideenter', {
          slideName: this.slides[newVal].slideName + addition,
          slideNumber: this.slides[newVal].slideName.split('-')[1],
          tagVariant: store.getters.getTagVariant
        })
      }, 300)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
    clearTimeout(this.externalSlideTimeout)
    // clearTimeout(this.localStorageTimeout)
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

body {
  box-sizing: border-box;
}

.appComp {
  height: auto;
  max-width: 100%;
  background-color: $color_bg_dark;
  margin: 0 auto;
  font-weight: 400;
  color: #333;
}

.appCompNewDesign {
  background-color: $color_bg_hausanker;
}

.container {
  padding-left: 64px;
  padding-right: 64px;
  padding-bottom: 64px;
  opacity: 0;
}

// note: new design
.containerNewDesign {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.animation {
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
}

.buttons {
  margin: 0 auto;
  height: 80px;
  display: flex;
  .overviewSign {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: -70px;
    .imgBox {
      display: inline-block;
      height: 46.83px;
      width: 41.56px;
      margin-right: 10.7px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .overviewText {
      width: 172px;
      font-size: 14px;
      line-height: 1.2;
      font-weight: 500;
    }
  }
  .icons {
    display: flex;
    align-items: center;
    align-self: center;
    height: 80px;
    width: 36.91%;
    padding-right: 20px;
    // margin-left: auto;
    .iconDiv {
      // height: 100%;
      margin-left: 20px;
      .img {
        height: 100%;
        display: inline-block;
      }
    }
  }

  .backNext {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 780px;
    margin-left: auto;
  }
}

.buttonText {
  display: inline-block;
  padding: 15px;
}

.back {
  margin-right: auto;
}
.listItems {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 26px;
  .listItem {
    line-height: 1.2;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    .imgBox {
      height: 30px;
      display: inline-block;
      margin-right: 18px;
      margin-left: 30px;
    }
    .text {
      display: inline-block;
    }
  }
}

// note: LAND
.land {
  .backNext {
    width: 60%;
  }
  .overviewSign {
    margin-left: 20px;
    margin-right: 0px;
  }
  .icons {
    justify-content: center;
  }
  .iconBig {
    img {
      max-width: 140px;
    }
  }
  .iconSmall {
    img {
      max-width: 70px;
    }
  }
}

// note: PORT
.port {
  .container {
    padding-right: 20px;
    padding-left: 20px;
  }
  .buttons {
    height: 60px;
    margin-top: 30px;
    .backNext {
      width: 100%;
    }
  }
}
// note: PHONE
.phone {
  height: auto;
  .container {
    padding-bottom: 20px;
  }
  .buttons {
    margin-top: 0;
  }
  button {
    width: 60%;
    font-size: 18px;
    padding-right: 15px;
    padding-left: 15px;
  }
  .back {
    flex: 0;
  }
  .backNext {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 0 0 100%;
    height: 60px;
    width: 100%;
  }
  .overviewSign {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    .imgBox {
      display: inline-block;
      height: 46.83px;
      width: 41.56px;
      margin-right: 10.7px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .overviewText {
      width: 172px;
      font-size: 14px;
      line-height: 1.2;
      font-weight: 500;
    }
  }
  .listItems {
    flex-direction: column;
    align-items: flex-start;
    .listItem:not(:last-child) {
      margin-bottom: 15px;
    }
    .imgBox {
      margin-left: 0px;
    }
  }
}
</style>
